module.exports = __webpack_public_path__ + "static/media/digestright1.0748e65a.pdf";